import {useAppStore} from '@/stores';

const useAuth = () => {
  const {currentUser} = useAppStore();
  return currentUser || {};
};

export default useAuth;
